import {
  isAndroidChatEnabled,
  isIOsChatEnabled,
} from "@faire/help-center-self-serve/utils/isMobileChatEnabled";
import { isChatInHolidayMode } from "@faire/help-center-self-serve/utils/isSupportServiceInHolidayMode";
import { brandChatbotSettingEnabledWithoutAssignment } from "@faire/help-center-utils/lib/brandChatbotSettingEnabled";
import { isAndroid, isIOS } from "@faire/help-center-utils/lib/isMobileApp";
import { retailerChatbotSettingEnabledWithoutAssignment } from "@faire/help-center-utils/lib/retailerChatbotSettingEnabled";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { useQuery as useJwtAuthQuery } from "@faire/web-api--source/api/help-center/messenger/auth/get-hooks";
import { IHCMessengerAuthResponse } from "@faire/web-api--source/indigofair/helpcenter/IHCMessengerAuthResponse";

type ChatAuthResponse = {
  isLoading: boolean;
  hasChatAccess: boolean;
  chatBtnEnabled: boolean;
  data: IHCMessengerAuthResponse | undefined;
  isChatInHolidayMode: boolean;
  isChatInBusinessHours: boolean;
};

export const useChatAuthorization = (): ChatAuthResponse => {
  const {
    data: authResponse,
    isLoading,
    status,
  } = useJwtAuthQuery({
    enabled:
      getIsLoggedInUser() &&
      !retailerChatbotSettingEnabledWithoutAssignment() &&
      !brandChatbotSettingEnabledWithoutAssignment(),
  });
  const jwt = authResponse?.jwt;
  // only status code is 200, the user has chat access
  const hasChatAccess = status === "success";
  // if jwt is provided, chat button is enabled, otherwise disabled
  const chatBtnEnabled = !!jwt;

  if (isChatInHolidayMode()) {
    return {
      isLoading: false,
      hasChatAccess: false,
      chatBtnEnabled: false,
      data: undefined,
      isChatInHolidayMode: true,
      isChatInBusinessHours: false,
    };
  }

  let platformChatEnabled = true;
  if (isAndroid()) {
    platformChatEnabled = isAndroidChatEnabled();
  } else if (isIOS()) {
    platformChatEnabled = isIOsChatEnabled();
  }

  return {
    isLoading,
    hasChatAccess: hasChatAccess && platformChatEnabled,
    chatBtnEnabled,
    data: authResponse,
    isChatInHolidayMode: false,
    isChatInBusinessHours: !!jwt,
  };
};
